<div class="page">

  <div class="pagehead">
    <div>
      <h1>Cash management services</h1>
      <p>Collect cash from customers against their CMS account</p>
    </div>
  </div>

  <div class="card form-card">
    <div class="clabel"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 8v8M9 12h6"/></svg>Collection details</div>
    <form [formGroup]="aepsCWForm" role="form" #form="ngForm" class="kit-form">
      <div class="form-grid">
        <div class="er-field er-field--amount"
          [class.has-error]="aepsCWForm.get('amountTowithdrawl').invalid && (aepsCWForm.get('amountTowithdrawl').touched || form.submitted)">
          <label class="er-field__label" for="cms-amount">Amount <span class="req">*</span></label>
          <div class="er-field__wrap">
            <span class="er-field__affix">₹</span>
            <input id="cms-amount" class="er-field__control" formControlName="amountTowithdrawl"
              placeholder="0" inputmode="numeric" autocomplete="off" (keypress)="numberOnly($event)">
          </div>
          <div class="er-field__help">₹100 – ₹10,000</div>
          <div class="er-field__error" *ngIf="aepsCWForm.hasError('required','amountTowithdrawl') && (aepsCWForm.get('amountTowithdrawl').touched || form.submitted)">Enter the amount</div>
        </div>

        <div class="er-field"
          [class.has-error]="aepsCWForm.get('mobile_no').invalid && (aepsCWForm.get('mobile_no').touched || form.submitted)">
          <label class="er-field__label" for="cms-mobile">Customer mobile number <span class="req">*</span></label>
          <div class="er-field__wrap">
            <input id="cms-mobile" class="er-field__control" formControlName="mobile_no"
              placeholder="10-digit mobile number" minlength="10" maxlength="10"
              inputmode="numeric" autocomplete="off" (keypress)="numberOnly($event)">
          </div>
          <div class="er-field__error" *ngIf="aepsCWForm.hasError('required','mobile_no') && (aepsCWForm.get('mobile_no').touched || form.submitted)">Enter the customer's mobile number</div>
        </div>
      </div>

      <div class="form-actions">
        <button type="submit" class="er-btn er-btn--primary" (click)="submit()">Collect cash</button>
      </div>
    </form>
  </div>

</div>

